module.exports = __webpack_public_path__ + "static/media/Brienne of Tarth.b6503944.jpg";